import React, { Children } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const IfEmpty = ({ children, className, message }) => (
  <div styleName="root" className={className}>
    {Children.count(children) > 0 ? (
      children
    ) : (
      <div styleName="message">{message}</div>
    )}
  </div>
);

IfEmpty.propTypes = {
  message: PropTypes.node.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

IfEmpty.defaultProps = {
  className: '',
};

export default IfEmpty;
